export default {
  home: "home",
  dashboard: "grid_view",
  request: "contract",
  service: "article",
  notification: "notifications",
  alert: "warning",
  department: "corporate_fare",
  users: "group",
  setting: "settings",
  time_loading: "avg_pace",
  menu: "menu",
  user: "person",
  password: "lock",
  eye_on: "visibility",
  eye_off: "visibility_off",
  identification: "badge",
  list: "article",
  email: "mail",
  phone: "phone",
  key: "key",
  search: "search",
  position: "person_apron",
  status: "sensors_krx",
  role: "settings_account_box",
  category: "category",
  description: "edit_note",
  type: "table_rows",
  institution: "corporate_fare",
  time: "schedule",
  delete: "delete",
  remove: "remove",
  add: "add",
  calendar: "calendar_month",
  close: "close",
  chevronDown: "expand_more",
  refresh: "refresh",
  arrowRightAlt: "arrow_right_alt",
  chevronRight: "chevron_right",
  chevronUp: "expand_less",
  failed: "close",
  chat: "chat",
  pin_drop: "pin_drop",
  analytics: "health_metrics",
  reports: "export_notes",
  donors: "groups",
  requests: "upcoming",
  dispatch: "local_shipping",
  warehouse: "warehouse",
  mobilize: "communication",
  hospitals: "local_hospital",
  alerts: "warning",
  feedback: "campaign",
  business: "corporate_fare",
  business_profile: "business_center",
  account_number: "account_balance",
  bank: "account_balance",
  bank_code: "vpn_key",
  address: "pin_drop",
  postal: "markunread_mailbox",
  country: "flag",
  location: "pin_drop",
  premium: "workspace_premium",
  board_members: "supervisor_account",
  contacts: "contacts",
  success: "check",
  numbers: "numbers",
  industry: "factory",
  documents: "home_storage",
  pin: "pin",
  back: "keyboard_backspace",
  postal: "markunread_mailbox",
  city: "location_city",
  download: "download",
  rate: "trending_up",
  fileUpload: "upload_file",
  bankAccount: "account_balance_wallet",
  chart: "monitoring",
  successTransaction: "checklist",
  failedTransaction: "tab_close",
  pendingTransaction: "history_toggle_off",
  directors: "supervisor_account",
  store: "store",
  charges: "payments",
  report: "lab_profile",
  transaction: "lab_profile",
  refund: "source_notes",
  receipt: "receipt",
  card: "credit_card",
  merchant: "storefront",
  invoice: "receipt_long",
  reconciliation: "account_balance_wallet",
};
